/*
 * JANGIN Chef Mingoo Challenge — grand prize background.
 *
 * Cross-fades between the background photos when there is more than one. The
 * fade itself is a CSS transition on .is-active; this only moves the class, so
 * with JS off the first layer stays visible rather than the band going black.
 */
(function () {
  var bg = document.querySelector('[data-prize-bg]');
  if (!bg) return;

  var layers = bg.querySelectorAll('.jangin-challenge-prize__layer');
  if (layers.length < 2) return;

  // A slideshow behind body copy is exactly what this media query is for.
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (still.matches) return;

  var section = bg.closest('.jangin-challenge-prize');
  var interval = parseInt(section.getAttribute('data-prize-interval'), 10);
  if (!interval || interval < 2000) interval = 6000;

  var i = 0;
  var timer = null;

  function advance() {
    layers[i].classList.remove('is-active');
    i = (i + 1) % layers.length;
    layers[i].classList.add('is-active');
  }

  function start() { if (!timer) timer = setInterval(advance, interval); }
  function stop() { clearInterval(timer); timer = null; }

  // Nothing to look at while the band is off screen, and a timer that keeps
  // running in a background tab is just wasted work.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries[0].isIntersecting ? start() : stop();
    }, { threshold: 0 }).observe(section);
  } else {
    start();
  }

  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : start();
  });
})();
